import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PhoneAnchor from 'bento-ordering/base/components/PhoneAnchor';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import {
  ITEM_DESCRIPTION_AND_PRICES,
  MENU_ITEM_NAMES
} from 'styles/constants/appearanceSectionNames';
import {
  getSectionNavLightColor,
  getSectionNavColor
} from 'styles/helpers/getThemeStyles';
import { useIsMobile } from 'styles/hooks/mediaQueries';

// TODO: These styles may need to be moved to a shared directory at a later time
export const detailsSx = {
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: '5px',
  fontSize: '16px',
  lineHeight: '19px',
  letterSpacing: '1px',
  color: 'white'
};

// TODO: These styles may need to be moved to a shared directory at a later time
const iconSx = {
  width: '16px',
  fill: 'white'
};

export const ownTextState = (ownStyles = () => ({})) => ({
  text: theme => ({
    color: getSectionNavColor(theme) ?? theme.palette.mediumSoy,
    ...ownStyles(theme)
  })
});

export const ownIconState = (ownStyles = () => ({})) => ({
  icon: theme => ({
    fill: getSectionNavLightColor(theme) ?? theme.palette.mediumSoy,
    ...ownStyles(theme)
  })
});

// TODO: These styles may need to be moved to a shared directory at a later time
const Details = styled(Typography, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme, ownState }) => {
  const ownTextState = ownState?.text?.(theme) ?? {};

  return {
    ...detailsSx,
    ...ownTextState
  };
});

// TODO: These styles may need to be moved to a shared directory at a later time
const DetailsBox = styled(Box)({
  display: 'flex',
  paddingTop: '7px',
  paddingRight: '15px'
});

const RestaurantName = styled(Typography, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme, ownState }) => {
  const ownTextState = ownState?.text?.(theme) ?? {};

  return {
    marginBottom: '22px',
    fontSize: '22px',
    letterSpacing: '0.25px',
    lineHeight: '26px',
    color: 'white',
    ...ownTextState
  };
});

// TODO: These styles may need to be moved to a shared directory at a later time
export function StandardMenuHeroRestaurantName({
  locationName,
  ownState = {}
}) {
  if (!locationName) {
    return null;
  }

  return (
    <RestaurantName variant={MENU_ITEM_NAMES} ownState={ownState} component="p">
      {locationName}
    </RestaurantName>
  );
}

StandardMenuHeroRestaurantName.propTypes = {
  locationName: PropTypes.string,
  ownState: PropTypes.object
};

const StyledLocationOnIcon = styled(LocationOnIcon, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme, ownState }) => {
  const ownIconState = ownState?.icon?.(theme) ?? {};

  return {
    ...iconSx,
    ...ownIconState
  };
});

// TODO: These styles may need to be moved to a shared directory at a later time
export function StandardMenuHeroAddress({
  street,
  city,
  state,
  postalCode,
  IconProps = {},
  DetailProps = {}
}) {
  const isMobile = useIsMobile();

  if (!street || !city || !state || !postalCode) {
    return null;
  }

  const { ownState: ownIconState = {} } = IconProps;
  const { ownState: ownDetailState = {} } = DetailProps;

  const content = isMobile
    ? street
    : `${street}, ${city}, ${state} ${postalCode}`;

  return (
    <DetailsBox>
      <StyledLocationOnIcon ownState={ownIconState} />
      <Details
        ownState={ownDetailState}
        variant={ITEM_DESCRIPTION_AND_PRICES}
        component="p"
      >
        {content}
      </Details>
    </DetailsBox>
  );
}

StandardMenuHeroAddress.propTypes = {
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postalCode: PropTypes.string,
  IconProps: PropTypes.object,
  DetailProps: PropTypes.object
};

const StyledPhoneIcon = styled(PhoneIcon, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme, ownState }) => {
  const ownIconState = ownState?.icon?.(theme) ?? {};

  return {
    ...iconSx,
    ...ownIconState
  };
});

export function StandardMenuHeroPhoneNumber({
  phoneNumber,
  IconProps = {},
  LabelProps = {}
}) {
  if (!phoneNumber) {
    return null;
  }

  const { ownState: ownIconState = {} } = IconProps;
  const { ownState: ownLabelState = {}, variant = 'body1' } = LabelProps;

  return (
    <DetailsBox>
      <StyledPhoneIcon ownState={ownIconState} />
      <PhoneAnchor
        number={phoneNumber}
        LabelProps={{
          variant,
          ownState: ownLabelState
        }}
      />
    </DetailsBox>
  );
}

StandardMenuHeroPhoneNumber.propTypes = {
  phoneNumber: PropTypes.string,
  IconProps: PropTypes.object,
  LabelProps: PropTypes.object
};
